const CREDIT_OUTPUT_ESTIMATE_RULES = [
  { key: 'xhs_note', label: '小红书笔记', shortLabel: '小红书', cost: 20, unit: '篇' },
  { key: 'wechat_article', label: '公众号文章', shortLabel: '公众号', cost: 30, unit: '篇' },
  { key: 'short_video', label: '标准短视频', shortLabel: '标准视频', cost: 200, unit: '条' },
];

export const toNonNegativeInt = (value) => {
  const n = Number(value || 0);
  if (!Number.isFinite(n) || n < 0) return 0;
  return Math.floor(n);
};

export const resolveCreditOutputEstimates = (credits) => {
  const amount = toNonNegativeInt(credits);
  return CREDIT_OUTPUT_ESTIMATE_RULES.map((rule) => {
    const count = rule.cost > 0 ? Math.floor(amount / rule.cost) : 0;
    return {
      key: rule.key,
      label: rule.label,
      shortLabel: rule.shortLabel,
      unit: rule.unit,
      value: count,
      text: `约 ${count}${rule.unit}`,
    };
  });
};

export const formatCreditEstimateSummary = (credits, options = {}) => {
  const amount = toNonNegativeInt(credits);
  if (amount <= 0) return '';
  const { includePrefix = false, compact = true, separator = ' / ' } = options;
  const summary = resolveCreditOutputEstimates(amount)
    .map((item) => `${item.value}${item.unit}${compact ? item.shortLabel : item.label}`)
    .join(separator);
  return includePrefix ? `约可生成 ${summary}` : summary;
};

export const formatCreditGrantText = (benefits) => {
  const amount = toNonNegativeInt(benefits?.credit_grant_amount);
  if (amount <= 0) return '';
  const mode = String(benefits?.credit_grant_mode || '').trim().toLowerCase();
  if (mode === 'once') return `一次性赠送 ${amount} 创作积分`;
  const intervalMonths = Math.max(toNonNegativeInt(benefits?.credit_grant_interval_months), 1);
  if (intervalMonths === 1) return `每月赠送 ${amount} 创作积分`;
  return `每 ${intervalMonths} 个月赠送 ${amount} 创作积分`;
};
